import { render, staticRenderFns } from "./accpetTerms.vue?vue&type=template&id=0c5fcc80&"
import script from "./accpetTerms.vue?vue&type=script&lang=js&"
export * from "./accpetTerms.vue?vue&type=script&lang=js&"
import style0 from "./accpetTerms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports